import captureSentryException from '../../../../tracking/sentry/captureSentryException';
import analytics from '../../index';

function copyHandler() {
  try {
    analytics.track('copy');
  } catch (e) {
    captureSentryException(e);
  }
}

export default copyHandler;
